<script>
import Layout from "../_layouts/main";
import PageHeader from "@/components/page-header";
import Page from '../../components/report/sub-money'

/**
 * Dashboard Component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Page
  },
  data() {
    return {
      title: "",
      state: ''
    };
  },
  mounted() {
    this.title = this.$t('menuitems.reportSubMoney.text')
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"></PageHeader>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <Page />
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
